import Text from "./Text";
import { Col, Row } from "./Flexbox";
import { authorizedDelete } from "../scripts/functions/AuthService";
const DeleteForecast = props => {

    const deleteForecast = async (forecast) => {
        try {
            const response = await authorizedDelete(`/forecast/deleteForecast/${forecast}`)
            // console.log("Response: ", response);
            
            props.refresh();    //Call getAllForecasts to update the list
            props.option("Generar Forecast");   //Send the user to generate a new forecast after deleting one.
            props.onClose();
        } catch (error) {
            console.error("Error deleting the forecast:", error);
        } 
        
    }

    return (
        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
            <Col style={{width:'100%', height: '100%', maxWidth: '450px', maxHeight: '250px', flex:'none', alignItems:'flex-start', paddingLeft: 32, paddingRight: 32, paddingTop: 32, paddingBottom: 32, marginTop: 32, backgroundColor: props.theme.White,  borderRadius: 4}}>
                <Col style={{width: '100%', justifyContent: 'start', paddingTop: 12, gap: 16, alignItems: 'start'}}>
                    <Text size={17} color={props.theme.ONED}>Confirma que desea eliminar el forecast actual?</Text>
                    <Text color={props.theme.SEVENB}>Esta acción no se puede deshacer</Text>
                </Col>
                <Row style={{width: '100%', justifyContent: 'space-between', paddingTop: 40, gap: 16}}>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={props.onClose} color={props.theme.Lao} size={15}>Cancelar</Text>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={() => deleteForecast(props.forecast)} color={props.theme.Magenta} size={15}>Eliminar forecast</Text>
                </Row>
            </Col>
        </div>
    )
}

export default DeleteForecast;